import { apiSlice } from "../apiSlice/apiSlice";

export const assignmentMarkApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllAssignmentMark: builder.query({
            query: () => '/assignmentMark'
        }),
        getAllPublishedAssignmentMark: builder.query({
            query: () => '/assignmentMark?status=published'
        }),
        getAssignmentMarkWithStudentIdAddAssignmentId: builder.query({
            query: ({ studentId, assignment_id }) => {

                return `/assignmentMark?student_id=${studentId}&assignment_id=${assignment_id}`
            }

        }),
        submitAssignment: builder.mutation({
            query: (data) => {

                return {
                    url: '/assignmentMark',
                    method: 'POST',
                    body: data,
                }
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const result = await queryFulfilled;
                const { data } = result || {}
                const { student_id, assignment_id } = data || {}

                // update data
                dispatch(apiSlice.util.updateQueryData(
                    "getAssignmentMarkWithStudentIdAddAssignmentId",
                    { studentId: student_id, assignment_id },
                    (draft) => {
                        draft.push(data);
                    }
                )
                );
                dispatch(apiSlice.util.updateQueryData(
                    "getAllAssignmentMark",
                    undefined,
                    (draft) => {
                        draft.push(data);
                    }
                )
                );

            }
        }),
        addAssignmentMark: builder.mutation({
            query: (info) => {

                return {
                    url: `/assignmentMark/${info.id}`,
                    method: "PATCH",
                    body: info
                }
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {


                // update data 
                const patchResult = dispatch(apiSlice.util.updateQueryData(
                    "getAllAssignmentMark",
                    undefined,
                    (draft) => {
                        const index = draft.findIndex(single => single.id === arg.id)
                        draft[index] = {
                            ...draft[index],
                            ...arg
                        }
                    }
                )
                );
                try {
                    const result = await queryFulfilled;
                } catch {
                    patchResult.undo()
                }

            }
        }),
    })
})
export const { useGetAllAssignmentMarkQuery, useGetAssignmentMarkWithStudentIdAddAssignmentIdQuery, useSubmitAssignmentMutation, useGetAllPublishedAssignmentMarkQuery, useAddAssignmentMarkMutation } = assignmentMarkApi;